import React, { useEffect } from 'react';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import store from "./store/index";
import { logout } from './store/user/actionCreators';
import { setBefourLoginUrl } from './store/global/actionCreators';
import { persistor } from "./store/index";
import routes from "./routes/index.js";
import { ACTIVE_FILE_DOWNLOAD } from 'src/fetch/url';
import { PersistGate } from 'redux-persist/lib/integration/react';
import {
  ConfigProvider,
} from "antd";
import { RETURN_DATA } from 'src/fetch/url';
import { CurlProvider } from 'zh-common-modules';
import { baseUrl } from 'src/config/url';
import './App.css';
import zhCN from "antd/es/locale/zh_CN";
import { showMessage } from 'src/components/util/NoticeMessage';
const resResponse = (response, res, rej) => {
  const { config: { url }, data } = response;
  const { success, message: messageStr, content } = data;
  if (success) {
    if (messageStr) {
      showMessage('success', messageStr);
    }
  } else {
    showMessage('error', messageStr);
    // rej(); //抛出错误
  }

  if (RETURN_DATA.includes(url)) {
    res(data);
    return;
  }
  res(content); //抛出数据，用.then获取数据
};

const errorHandle = (error, rej) => {
  const { status, data } = error.response || { status: 'unknown', data: {} };
  const { message: messageStr, success } = data;
  let statusText = '';
  if (messageStr && !success) {
    statusText = messageStr;
    if (status === 401) {
      // const user = store.getState().user;
      store.dispatch(logout());
      store.dispatch(setBefourLoginUrl(window.location.pathname));
      // if (user.isLogin) {
      //   store.dispatch(logout());
      // }
    }
  } else {
    switch (status) {
      case 404:
        statusText = '请求地址有误';
        break;
      case 401:
        statusText = '身份过期，请重新登陆。';
        break;
      case 403:
        statusText = '当前用户没有该权限。';
        break;
      case 500:
        statusText = '服务器错误';
        break;
      default:
        statusText = `错误(${status})!`;
        break;
    }
  }
  rej(error);
  if (statusText !== '') {
    showMessage('error', statusText);
  }

};

const requestInterceptors = request => {
  const { url } = request || {};
  request.timeout = 0;
  if (url === ACTIVE_FILE_DOWNLOAD) {
    request.data = true;
  }
  return request;
};

const auth = () => {
  const keys = document.cookie.match(/[^ =;]+(?==)/g) || [];
  return !!keys.includes('token');
};

function App() {
  useEffect(() => {
    const isShuzhi = process.env.REACT_APP_ENV === "shuzhi";
    document.title = isShuzhi ? 'SINWO' : '统一支撑平台';
  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <CurlProvider
              responseHandle={resResponse}
              errorHandle={errorHandle}
              auth={auth}
              configs={{
                baseUrl: baseUrl,
                requestInterceptors,
              }}
            >
              {renderRoutes(routes)}
            </CurlProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ConfigProvider>
  );
}

export default App;
